import { gql, type OperationVariables } from '@apollo/client';
import type { EGender } from '@sharedInterfaces/IEmployee';

import GraphQL from '../graphQL';

const query = gql`
mutation updateMyGender($gender: String!) {
    updateMyGender(gender: $gender) 
},
`;

export default async function updateMyGender(gender: EGender) {
    const variables: OperationVariables = {
        gender,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
